<div class="row" *ngFor="let stepper of steppers; index as i;">

    <div class="col-4" (click)="jumpStepper(stepper)" [ngClass]="{'step-one' : stepper.active}">
        {{stepper.title}}
    </div>
    <!-- background should change to blue when active -->
    <div class="circle last{{i}}" *ngIf="stepper.isProgress === 'true'" [ngClass]="{'step-active' : stepper.active,'div.circle.last2' : IsCompliance}"
         (click)="jumpStepper(stepper)"></div>

    <div class="circle step-active" *ngIf="stepper.isProgress === 'false'" (click)="jumpStepper(stepper)">
       <span class="icon"><i class="fa fa-check"></i></span> 
    </div>

</div>

<div class="stepper-content">

    <ng-content></ng-content>

</div>
